import styled, { css } from 'styled-components'
import { Typography } from '@material-ui/core'

export const LastUpdateDate = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.brand.darkGray};
  `
)
